import { gql } from '@apollo/client';

export const LOCK_ARTICLE = gql`
  mutation LockArticle($where: ArticleUniqueFilterInput!) {
    lockArticle(where: $where)
  }
`;

export const RETAIN_LOCK_ARTICLE = gql`
  mutation RetainLockArticle($where: ArticleUniqueFilterInput!) {
    retainArticleLock(where: $where)
  }
`;

export const UNLOCK_ARTICLE = gql`
  mutation UnlockArticle($where: ArticleUniqueFilterInput!) {
    unlockArticle(where: $where)
  }
`;
